import { useEffect, useState } from "react";
import MenuComponent from "../component/MenueComponent";
import { MyFooter } from "./MyFooter";

export type IKategorie = {
  id: number,
  name: string,
  startzeit: string,
  teilnahmegebuehr: number,
}

export function LandingPage() {

  const [kategorien, setKategorien] = useState<IKategorie[]>([]);

  const getData = () => {

    fetch(process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_PATH! + "/restGetKategorienAktuell.rest")
      .then(response => response.json())
      .then(setKategorien)
      .catch((e) => console.log(e));
  }

  useEffect(() => {
    getData();
  }, []);


  const headerElement = (
    <div className="inline-flex align-items-center justify-content-center gap-2">

    </div>
  );

  const startImg = (
    <>
      <img src="img/start.jpg" style={{ "objectFit": "contain", width: "100%", marginTop: "70px" }} />
    </>
  )

  const bildKindergarten = (
    <img src="img/kg2023.jpg"
      style={{ "objectFit": "contain", "width": "100%", "marginTop": "70px" }} />
  )

  const video = (
    <>
      <div className="d-md-none d-lg-block"
        style={{ "width": "100%", "zIndex": -1, "opacity": "1" }}>
        <video className="d-none d-lg-block" style={{ "objectFit": "cover" }}
          id="video_background" src="../vl2022.mp4"
          //type="video/mp4"
          autoPlay={true} loop={true} muted={true} preload="metadata">
        </video>
      </div>
    </>
  )

  const formatpreis = (num: number): string => {
    const options = { maximumFractionDigits: 2 }
    const formattedNumber = Intl.NumberFormat("de-DE", options).format(num);
    return formattedNumber;
  }

  return (


    <div className="wrapper" id="">

      <div className="max-w-7xl mx-auto px-4">

        <div className="content row">

          <MenuComponent aktuelleseite="startseite" />

          {/*<div className={styles.landingpageHeroContainer}>

                <div className={styles.landingpageHeroHeadline}>Volkslauf Neermoor</div>

              </div>*/}
          {/*<div className="col-md-3 col-lg-3 px-4" role="main"></div>*/}



          { /*video()*/}

          <div style={{ width: "100%" }}>

            {/*startImg*/}

            { /* bildKindergarten */}

            <div className="max-w rounded overflow-hidden shadow-lg text-2xl mt-20">
              <div className="card-body" style={{ "width": "100%", padding: "30px" }}>
                <h4 style={{ "textAlign": "center" }}>Volkslauf Neermoor 2026</h4>
                <h4 style={{ "textAlign": "center" }}>am Sonntag dem 28.06.2026</h4>
                <h4 style={{ "textAlign": "center" }}>in der Wilhelmsstr. 2 in 26802 Moormerland</h4>
              </div>
            </div>


            <div className="max-w rounded overflow-hidden shadow-lg mt-12 p-4">

              Diesjähriges Motto:
              <div className="flex justify-center">
                <img src="img/nöös_an_nöös.jpeg" style={{ height: "300px", width: "300px" }} />
              </div>

              <div>
                <p className="text-2xl">Liebe Läufer,</p>
                <p>
                  der Volkslauf Neermoor findet wieder statt!
                </p>
                <p>
                  Folgende Kategorien gehen an den Start:
                </p>
                <table className='table' style={{ "width": "100%" }}>
                  <thead>
                    <tr>

                      <th>Lauf</th>
                      <th>Uhrzeit</th>
                      <th>Startgeld</th>
                    </tr>
                  </thead>
                  <tbody>
                    {kategorien.map((e, index) =>
                      <>
                        <tr key={'' + index}>
                          <td>{e.name}</td>
                          <td>{e.startzeit}</td>
                          <td>{formatpreis(e.teilnahmegebuehr)} EUR</td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>

                {/*<a className="btn btn-primary" href="AusschreibungVL2026.pdf"
                      target="_blank">
                      Download Ausschreibung als PDF Datei
                    </a>*/}

              </div>
            </div>

            <div className="max-w rounded overflow-hidden shadow-lg mt-12 p-4">
              <h3>Startgebühr</h3>

              <ul>
                <li>Für die Kinderläufe U6, U8, U10 und U12 wird 2 Euro
                  Startgebühr genommen.</li>
                <li>Für alle anderen Läufe beträgt die Startgebühr 5 Euro.</li>
                <li>Alle Teilnehmer, die sich erst am Sonntag am Schalter
                  anmelden müssen 2 EUR zusätzlich bezahlen. Die Schalter öffnen um 8:30 Uhr</li>
              </ul>

              Nach der Onlineanmeldung werden in der Bestätigungsemail die
              Daten für die Überweisung der Teilnahmegebühr mitgeteilt.
            </div>

            <div className="max-w rounded overflow-hidden shadow-lg mt-12 p-4">
              <h3>Wie läuft die Anmeldung?</h3>
              Sobald die Anmeldung freigeschaltet wurde könnt Ihr Euch direkt <a href="anmeldung/">hier</a> eintragen. Nach der Anmeldung erhaltet Ihr eine eine E-Mail mit den Daten für die Überweisung der Startgebühren.
            </div>

          </div>

        </div>

        <MyFooter />

      </div>
    </div>

  );
}

export default LandingPage;